
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export enum LabName  { mainnet, testnet};
export type NodeLab =  9093 | 9092 ;
export type ProxyLab = 8093 | 8092 ;
export type EnvLab = "prod" | "testnet" ;

export type labType = {
    name: LabName,
    nodeLab: number,
    proxyLab: number,
    dexAddress: string,
    env: EnvLab,
    isMain: boolean
}

//! prod.dexAddress is equal to demo.dexAddress for now. need to change that when prod will have dex safe
const labs: labType[] = [
    {name : LabName.mainnet, nodeLab: 9093, proxyLab: 8083, dexAddress: "omnistar1kxkvhxcujmwzps6e5jy6urv83l8yfns86sjhd6", env: "prod", isMain: true},
    {name : LabName.testnet, nodeLab: 9092, proxyLab: 8082, dexAddress: "omnistar1dkxtmsrhdx45hry92qczft9sjjq2h3dje2nph6", env: "testnet", isMain: false},
]

export interface LabState {
    labName: LabName,
    nodeLab: NodeLab,
    proxyLab: ProxyLab,
    env: EnvLab,
    isMain: boolean
}

export type labCotextType = {
    lab?: labType,
    changeLab: (labName: LabName) => void,
}

export const LabContext = React.createContext<labCotextType>({
  changeLab: (labName: LabName) => {
    console.log(labName);
  }
});

export const LabProvider = ({children}: {children? : React.ReactNode}) => {
    const [selectedLab, setSelectedLab] = useState<labType>();
    const { search } = useLocation();
    const labParam = new URLSearchParams(search).get('lab');

    const changeLab = (labName: LabName) => {
        try{
            let i: number = Number(LabName[labName]);
            if(i === 0 || i === 1){
                let lab: labType = labs[i];
                setSelectedLab(()=> lab);
            }
        } catch(e){
            console.error(e);
            setSelectedLab(()=>labs[0]);
            
        }
    }

    useEffect(() => {
            if(!labParam){
                setSelectedLab(()=>labs[0]);
            } else
            if (!selectedLab || labParam !== LabName[selectedLab.name]){
                changeLab(labParam as unknown as LabName);
            }
        },[labParam,selectedLab])
    const valueProvider: labCotextType = {
        lab: selectedLab,
        changeLab: changeLab
    };

    return (
        <LabContext.Provider value={valueProvider}>
          {children}
        </LabContext.Provider>
    );

}
